<mat-tab-group [selectedIndex]="selectedTabIndex()" mat-stretch-tabs="false">
  @for (item of menuItems; track item) {
    <ng-container *ganIfHasScope="item.someScopeRequired || []">
      <mat-tab>
        <ng-template mat-tab-label>
          <gan-link [routerLink]="item.path" class="menu-item">
            {{ item.label | translate }}
          </gan-link>
        </ng-template>
      </mat-tab>
    </ng-container>
  }
</mat-tab-group>
